import { render } from "./play-pause-control.vue?vue&type=template&id=0b4379ae"
import script from "./play-pause-control.vue?vue&type=script&lang=js"
export * from "./play-pause-control.vue?vue&type=script&lang=js"

import "./play-pause-control.vue?vue&type=style&index=0&id=0b4379ae&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__